export const PromptManagementSystemPagesTypes = {
  PAGE_LIST: "list",
  PAGE_CREATE: "create",
  PAGE_EDIT: "edit"
};
